<div class="hotel-gallery-container">
  <app-horizontal-slider
    [grid]="grid"
    [cards]="getCards()"
    [cardsLength]="cardsLength"
    [firstArray]="firstArray"
    (clickOn)="emitClick($event)"
    (positionChanged)="onPositionChanged($event)"
  />
</div>
